import { DefaultToggle } from "../../../../common/components/forms/inputs/toggle/DefaultToggle";
import { useNewReservationNotifications } from "../hooks/useNewReservationNotifications";
import styles from "./NewReservationNotificationsSection.module.scss";

export const NewReservationNotificationsSection = () => {
  const { byEmail, byPush, isLoading, isSaving, canUsePush, onEmailChange, onPushChange } =
    useNewReservationNotifications();

  return (
    <div className={styles.card}>
      <span className={styles.cardTitle}>Нови резервации</span>

      {isLoading ? (
        <div className={styles.skeleton} />
      ) : (
        <div className={styles.switches}>
          <DefaultToggle
            name="newReservationsByEmail"
            label="Имейл"
            standalone
            width="100%"
            checked={byEmail}
            disabled={isSaving}
            onChange={onEmailChange}
          />
          {canUsePush && (
            <DefaultToggle
              name="newReservationsByPush"
              label="Известие на устройството"
              standalone
              width="100%"
              checked={byPush}
              disabled={isSaving}
              onChange={onPushChange}
            />
          )}
        </div>
      )}

      <p className={styles.text}>
        Ще получавате само резервациите за вашите часове. За всички резервации в обекта
        собственикът или администраторът може да добави имейла ви в Настройки на обекта →
        Напомняния → Имейл за известия при нови резервации.
      </p>
    </div>
  );
};
